import { BsCodeSlash } from "react-icons/bs";
import { GoChecklist } from "react-icons/go";
import { VscNotebook } from "react-icons/vsc";
import { AiOutlineHome } from "react-icons/ai";
import { TbSunElectricity } from "react-icons/tb";
import { PiEnvelopeSimpleOpen } from "react-icons/pi";
import { MdOutlineWorkHistory } from "react-icons/md";

export const UseNavItems = [
  {
    path: "#hello",
    label: "Hello",
    icon: <AiOutlineHome className="text-lg" />,
  },
  {
    path: "#experiences",
    label: "Experience",
    icon: <MdOutlineWorkHistory className="text-lg" />,
  },
  {
    path: "#skills",
    label: "Skills",
    icon: <BsCodeSlash className="text-lg" />,
  },
  {
    path: "#projects",
    label: "Projects",
    icon: <GoChecklist className="text-lg" />,
  },
  {
    path: "#strengths",
    label: "Strengths",
    icon: <TbSunElectricity className="text-lg" />,
  },
  /* {
      path: "#blogs",
      label: "Blog",
      icon: <TfiWrite className="text-[16px]" />,
    }, */
  {
    badge: 0,
    path: "#contact",
    label: "Contact",
    icon: <PiEnvelopeSimpleOpen className="text-lg" />,
  },
  {
    // path: "https://drive.google.com/file/d/1GJQ6Y7NC1Skc0VuRxPTGq0SSConU6cXY/view",
    external: true,
    label: "Resume",
    path: "/resume.html",
    icon: <VscNotebook className="text-[16px]" />,
  },
];
